import React from "react";
import BlogImage from "../../images/blog-holder.png";
import { navigate } from "gatsby";
import Icon from "../UIElements/Icons";

export default function SearchTile({
    title,
    image,
    url,
    type,
    date,
    subTitle,
    searchValue
}) {
    return (
        <div className="rounded-md bg-white p-2" >
            <div
                className="cursor-pointer" 
                onClick={() => {
                typeof window !== "undefined" && window?.gtag && window.gtag("event", "uber_search", { 
                    'event_category': 'select',
                    'event_label': searchValue,
                    'value': url
                })
                navigate(url);
            }}>
                <div className="grid grid-cols-3">
                    <div>
                        {image ? 
                        type === "Employee" ? <img src={image} alt="" className="aspect-3/2 w-full rounded-md object-top object-cover max-h-[250px]"/> : <img src={image} alt="" className="aspect-4/2 w-full rounded-md object-cover max-h-[250px]"/> : 
                        <img src={BlogImage} alt="" className="aspect-[1.9] w-full rounded-md object-cover max-h-[250px]"/>
                    }
                    </div>
                    <div className="flex mx-2 col-span-2 h-full items-center">
                        <div className="relative">
                            <div className="text-orange-500 text-sm flex"><Icon type={type} colour={"orange"} className={"h-6 w-6 -mt-[3px]"}/> {type} {date ? `| ${date}` : null }</div>
                            <div className="font-title font-semibold text-plum-900" dangerouslySetInnerHTML={{__html: `<p class="searchTile">${title}</p>`}}></div>
                            {subTitle ? <div className="text-plum-900" dangerouslySetInnerHTML={{__html: `<p class="searchTile">${subTitle}</p>`}}></div> : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}